import { Container, Typography, Card, CardContent, Grid, CardMedia, Link } from "@material-ui/core";
import { authContext } from "helpers/services";
import { useContext } from "react";

let Error403 = () => {
    let authService = useContext(authContext);

    return (
        <Container maxWidth="lg">
            <Card elevation={0}>
                <CardContent>
                    <Grid container spacing={2} alignContent="center">
                        <Grid item xs>
                            <Typography align="center" variant="h2">
                                403: We are sorry but we are not able to authorize you.
                            </Typography>
                            <Typography align="center" variant="body2">
                                You either tried some shady route or you came here by mistake. Whichever
                                it is, <Link component="button" onClick={() => authService.signOut()}>click here</Link>&nbsp;to come back to login
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardMedia
                    height="500"
                    component="img"
                    image="/images/errors/401.svg"
                    style={{ objectFit: 'inherit' }}
                />
            </Card>
        </Container>
    )
}

export default Error403;